import React from "react";
import { Link } from "react-router-dom";

export default () => <>
  <div style={{
    width: "100vw",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign:"center",
    color:"var(--main-cyan)"
  }}>
    <h1 style={{fontSize:"9em",marginBottom:"0"}}>404</h1>
    <h1>Страница не найдена</h1>
    <Link to="/"><button style={{transform:"scale(1.5)"}} className="basket_footer_btn">Назад</button></Link>
  </div>
</>